import React, { useEffect, useState } from "react";
import { signInWithCustomToken } from "firebase/auth";
import { Y, T } from "../theme";
import { API_BASE, auth } from "../firebase";

// Discord OAuth landing page. Two modes:
//
//   Popup mode (desktop): loaded inside the popup window opened by
//   runDiscordPopup. Posts the result to window.opener and closes itself.
//
//   Redirect mode (mobile, where popups are unreliable): same page, but
//   loaded as a full navigation. Finishes sign-in / link inline and
//   replaces the URL back to wherever the user came from.
export default function DiscordCallback() {
  const [message, setMessage] = useState("Signing in via Discord…");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code     = params.get("code");
    const state    = params.get("state");
    const errParam = params.get("error_description") || params.get("error");

    let isPopup = false;
    try { isPopup = !!(window.opener && !window.opener.closed); } catch (_) {}

    const finishPopup = (msg) => {
      try {
        if (window.opener) window.opener.postMessage({ type: "discord-auth", ...msg }, "*");
      } catch (_) {}
      // Give the opener a tick to receive the message before we close.
      setTimeout(() => { try { window.close(); } catch (_) {} }, 200);
    };

    const finishRedirect = async (msg) => {
      let returnTo = "/";
      try {
        const stash = JSON.parse(sessionStorage.getItem("discordOAuth") || "{}");
        if (stash && typeof stash.returnTo === "string") returnTo = stash.returnTo || "/";
      } catch (_) {}
      try { sessionStorage.removeItem("discordOAuth"); } catch (_) {}

      if (msg.ok && msg.mode === "signin" && msg.customToken) {
        try {
          await signInWithCustomToken(auth, msg.customToken);
        } catch (e) {
          setMessage(`Sign-in failed: ${e.message || e}`);
          return;
        }
      }
      if (!msg.ok) {
        // Surface the error briefly, then send the user back so they can retry.
        setTimeout(() => { window.location.replace(returnTo); }, 1500);
        return;
      }
      window.location.replace(returnTo);
    };

    const finish = (msg) => (isPopup ? finishPopup(msg) : finishRedirect(msg));

    if (errParam) {
      setMessage(`Sign-in failed: ${errParam}`);
      finish({ ok: false, error: String(errParam) });
      return;
    }
    if (!code || !state) {
      setMessage("Sign-in failed: missing code or state");
      finish({ ok: false, error: "Missing authorization code or state" });
      return;
    }

    fetch(`${API_BASE}/api/auth/discord/exchange`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code, state }),
    })
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.error || `Sign-in failed (${r.status})`);
        setMessage(isPopup ? "Signed in. You can close this window." : "Signed in. Redirecting…");
        finish({ ok: true, ...data });
      })
      .catch((e) => {
        setMessage(`Sign-in failed: ${e.message}`);
        finish({ ok: false, error: e.message || "Sign-in failed" });
      });
  }, []);

  return (
    <div style={{
      minHeight: "100vh", background: T.bg, color: T.title,
      fontFamily: "Mulish,sans-serif",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 24, fontSize: 14,
    }}>
      <div>{message}</div>
    </div>
  );
}
